var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"0.14rem"}},[_vm._v(" 请使用PC登录 ")])}
var staticRenderFns = []

export { render, staticRenderFns }